<template>
  <div :class="{main: data.isMain}" @click="emit('open')">
    <div class="ingredient__badge" v-if="data.badgeUrl">
      <img :src="data.badgeUrl">
    </div>
    <div class="ingredient__image">
      <img :src="data.imageUrl">
    </div>
    <div class="ingredient__name">{{ data.name }}</div>
    <div class="ingredient__plus">
      <svg width="24.000000" height="24.000000" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path id="Vector 45" d="M12 0L12 24" stroke="#FFFFFF" stroke-opacity="1.000000" stroke-width="2.000000"/>
        <path id="Vector 46" d="M24 12L0 12" stroke="#FFFFFF" stroke-opacity="1.000000" stroke-width="2.000000"/>
      </svg>
    </div>
  </div>
</template>

<script setup>
import { defineEmits } from 'vue';
  const props = defineProps({
    data: {
      type: Object,
      default: {}
    }
  });

  const emit = defineEmits(['open']);



</script>
